// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9bfbe0bd","453":"6dc70db0","732":"b2d6037b","977":"7c7983f0"}[chunkId] + ".chunk.js";
};